import dayjs from 'dayjs'
import utc from 'dayjs/plugin/utc'
import isBetween from 'dayjs/plugin/isBetween'
import customParseFormat from 'dayjs/plugin/customParseFormat'
import { getCPDataWithoutParams } from 'src/clinic/services'
import { appVersion, platformWeb } from 'src/consumer/services'
import { getTimezoneOffset } from 'src/consumer/helpers/utilFunctions'
import { queueAudioAndSpeech } from 'src/textToSpeechUtil'

dayjs.extend(utc)
dayjs.extend(isBetween)
dayjs.extend(customParseFormat)

export function shouldShowYoutubeVideoForOOH(thisClinicData) {
  // let returnBool = false
  // const scheduleForToday = getDefaultScheduleFromSchedules(thisClinicData?.schedules)
  //   ?.weeklyHourMap?.[dayjs()?.format('dddd')?.toLowerCase()]
  // // skipping the timezone consideration here as no need to internationalize it now
  // if (scheduleForToday?.available) {
  //   const timeNow = dayjs()?.format('HH:mm:ss')
  //   for (const slot of scheduleForToday.slotList) {
  //     const timeMomentStart = dayjs(slot.startTime, 'HH:mm:ss').subtract(2, 'hours')
  //     const newTimeStart = timeMomentStart.format('HH:mm:ss')

  //     const timeMomentEnd = dayjs(slot.endTime, 'HH:mm:ss').add(2, 'hours')
  //     const newTimeEnd = timeMomentEnd.format('HH:mm:ss')

  //     if (timeNow >= newTimeStart && timeNow <= newTimeEnd) {
  //       returnBool = true
  //     }
  //   }
  // }
  // return returnBool

  const currentTime = dayjs().format('HH:mm:ss')
  const startTime = dayjs('09:00:00', 'HH:mm:ss')
  const endTime = dayjs('21:00:00', 'HH:mm:ss')

  const isBetween9AMAnd9PM = dayjs(currentTime, 'HH:mm:ss').isBetween(startTime, endTime)
  return isBetween9AMAnd9PM
}

export async function getActiveMentorsInAClinicLocation({
  clinicLocationId,
  apiScope = 'kiosk',
}) {
  const response = await getCPDataWithoutParams(
    `/api/secure/${apiScope}/active-mentors-in-clinic?clinicLocationId=${clinicLocationId}&zoneOffset=${encodeURIComponent(
      getTimezoneOffset(),
    )}&appVersion=${appVersion}&platformType=${platformWeb}`,
  )
  if (response.status === 200) {
    return response?.data
  }
  return {}
}

async function getMentorForClinicAssistant({ serviceProviderId }) {
  const response = await getCPDataWithoutParams(
    `/api/secure/clinic-assistant/service-provider?id=${serviceProviderId}&zoneOffset=${encodeURIComponent(
      getTimezoneOffset(),
    )}&appVersion=${appVersion}&platformType=${platformWeb}`,
  )
  if (response.status === 200) {
    return response?.data
  }
  return null
}

export async function getMentorListForClinicAssistant({ serviceProviders = [] }) {
  // let mentorList = await Promise.all(
  //   serviceProviders.map((serviceProvider) =>
  //     getMentorForClinicAssistant({ serviceProviderId: serviceProvider?.id }),
  //   ),
  // )
  let mentorList = serviceProviders

  mentorList = mentorList.filter((mentor) => !!mentor)

  return mentorList?.sort((a, b) => {
    return a?.title?.localeCompare(b?.title)
  })
}

export const compareStartTime = (a, b) => {
  const dateA = new Date(a.slotStart)
  const dateB = new Date(b.slotStart)
  return dateA - dateB
}

export const compareStartTimeForLatestFirstTime = (a, b) => {
  const dateA = new Date(a.slotStart)
  const dateB = new Date(b.slotStart)
  return dateB - dateA
}

export function getNextCompletedBookedSlots({ bookedSlots }) {
  let nextBookingsDue = bookedSlots?.sort(compareStartTime)
  let firstPatientDueIndex = 0
  nextBookingsDue?.forEach((item, idx) => {
    if (item?.markedCompleted) {
      firstPatientDueIndex = idx + 1
    }
  })
  return nextBookingsDue?.slice(firstPatientDueIndex) || []
}

export async function getAndSetBookedSlotsOfMentorAtSelectedDate({
  screeningMentor,
  selectedDateUtcStartTime,
  selectedDateUtcEndTime,
  clinicId,
  apiScope = 'kiosk',
}) {
  // let response = await getCPDataWithoutParams(
  //   `/api/secure/clinic-assistant/booked-slots/all?mentorId=${screeningMentor?.id}&doctorId=${screeningMentor?.id}&startTime=${selectedDateUtcStartTime}&endTime=${selectedDateUtcEndTime}`,
  // )
  let response2 = await getCPDataWithoutParams(
    `/api/secure/${apiScope}/ooh/appointment-numbers?mentorId=${screeningMentor?.id}&clinicId=${clinicId}&startTime=${selectedDateUtcStartTime}&endTime=${selectedDateUtcEndTime}`,
  )
  // if (response?.status === 200) {
  //   if (Array.isArray(response?.data) && response?.data?.length > 0) {
  //     console.log({ orignalBookedSlots: response?.data })

  //     let nextBookingsDue = response?.data?.sort(compareStartTime)
  //     let firstPatientDueIndex = 0
  //     nextBookingsDue?.forEach((item, idx) => {
  //       if (item?.markedCompleted) {
  //         firstPatientDueIndex = idx + 1
  //       }
  //     })
  //     return nextBookingsDue.slice(firstPatientDueIndex)
  //   }
  // }
  if (response2?.status === 200) {
    if (Array.isArray(response2?.data) && response2?.data?.length > 0) {
      return response2?.data
    }
  }
  return []
}

export async function getScreenersWithTheirBookedSlots({
  screeners = [],
  selectedDateUtcStartTime,
  selectedDateUtcEndTime,
  clinicId,
  apiScope = 'kiosk',
}) {
  let screenersWithBookedSlots = await Promise.all(
    screeners?.map(async (screeningMentor) => {
      let slots = await getAndSetBookedSlotsOfMentorAtSelectedDate({
        screeningMentor,
        selectedDateUtcStartTime,
        selectedDateUtcEndTime,
        clinicId,
        apiScope,
      })
      return { ...screeningMentor, bookedSlots: slots }
    }),
  )


  return screenersWithBookedSlots?.sort((a, b) => {
    return a?.title?.localeCompare(b?.title)
  })
}

export function getUpdatedActiveAppointmentMapAndAnnounceForChanges(
  activeAppointmentMap,
  mentorId,
  mentorName,
  mentorLatestAppointmentNumber,
  mentorNextAppointmentNumber,
  isMainMentorAvailableInClinic = true,
  lang = 'hi',
  announcementsEnabled = true,
) {

  // Early returns for invalid states
  if (!activeAppointmentMap) return {}
  if (!mentorName) return activeAppointmentMap

  // Remove mentor if no latest appointment
  if (!mentorLatestAppointmentNumber) {
    delete activeAppointmentMap[mentorId]
    return activeAppointmentMap
  }

  const currentAppointmentNumber = activeAppointmentMap[mentorId]

  // Update appointment number if it's different or doesn't exist
  if (currentAppointmentNumber !== mentorLatestAppointmentNumber) {
    activeAppointmentMap[mentorId] = mentorLatestAppointmentNumber

    // Only call patient if mentor is present in clinic AND audio is enabled.
    if (isMainMentorAvailableInClinic) {
      if (announcementsEnabled) {
        callPatient(mentorLatestAppointmentNumber, mentorNextAppointmentNumber, mentorName, lang)
      }
    } else {
      //doing this so that the next time the mentor is available in clinic, the patient is called
      delete activeAppointmentMap[mentorId]
    }
  }

  return activeAppointmentMap
}

function callPatient(thisPatientToken, nextPatientToken, mentorName, language) {
  if (thisPatientToken && mentorName) {
    if (language === 'hi') {
      // queueAudioAndSpeech(
      //   '/pre_text_tone_1.wav',
      //   `<speak>टोकन नंबर ${thisPatientToken} ${formatMentorName(
      //     mentorName,
      //   )} के चैम्बर में आईये।<break time="1000ms"/>नंबर ${thisPatientToken} ${formatMentorName(
      //     mentorName,
      //   )} के चैम्बर में आईये।<break time="1000ms"/>नंबर ${thisPatientToken} ${formatMentorName(
      //     mentorName,
      //   )} के चैम्बर में आईये।</speak>`,
      //   'hi-IN',
      // )

      queueAudioAndSpeech(
        '/pre_text_tone_1.wav',
        `टोकन नंबर ${thisPatientToken} ${formatMentorName(mentorName)} के चैम्बर में आईये।`,
        'hi-IN',
      )
    } else {
      queueAudioAndSpeech(
        '/pre_text_tone_1.wav',
        `Token ${thisPatientToken}, please meet${mentorName}, ${thisPatientToken}`,
        'en-IN',
      )
    }
  }
  if (nextPatientToken && mentorName) {
    if (language === 'hi') {
      queueAudioAndSpeech(
        '/pre_text_tone_1.wav',
        `${nextPatientToken}, ${formatMentorName(mentorName)} से मिलने के लिए तैयार रहिये।`,
        'hi-IN',
      )
    } else {
      queueAudioAndSpeech(
        '/pre_text_tone_1.wav',
        `Get Ready, token ${nextPatientToken} for ${mentorName}`,
        'en-IN',
      )
    }
  }
}

export function getScreenTitleForMentor(mentorProfileData) {
  if (Array.isArray(mentorProfileData?.categories)) {
    if (mentorProfileData.categories.includes('clinical_psychologist')) {
      return 'Psychologist'
    }
    if (
      mentorProfileData.categories.includes('counselling_psychologist') &&
      mentorProfileData.categories.includes('therapist')
    ) {
      return 'Therapist'
    }
    // Check for therapist category (should come before doctor check)
    if (mentorProfileData.categories.includes('therapist')) {
      return 'Therapist'
    }
    if (
      mentorProfileData.categories.includes('doctor') &&
      mentorProfileData.categories.includes('psychiatrist')
    ) {
      return 'Pyschiatrist'
    }
    if (
      mentorProfileData.categories.includes('doctor') &&
      Array.isArray(mentorProfileData.specializedCategories) &&
      mentorProfileData.specializedCategories.includes('psychiatrist')
    ) {
      return 'Pyschiatrist'
    }
    // Check for doctor category as fallback
    if (mentorProfileData.categories.includes('doctor')) {
      return 'Doctor'
    }
  }
  // Default fallback - return empty string if no categories match
  return ''
}

export function getPrefixRemovedAppointmentNumber(appointmentNumber) {
  if (appointmentNumber) {
    const match = appointmentNumber.match(/^([A-Za-z]+)(\d+)$/)
    if (match) {
      return match[2]
    }
    return appointmentNumber
  }
  return null // If appointment number is null or undefined
}

export function formatMentorName(mentorName) {
  if (!mentorName || typeof mentorName !== 'string') {
    console.error('Invalid mentor name provided.')
    return mentorName
  }

  // Check if the name starts with 'Dr ' or 'Dr. ' (case-insensitive)
  if (/^dr\.?\s/i.test(mentorName)) {
    // Replace 'Dr ' or 'Dr. ' with 'Doctor '
    return mentorName.replace(/^dr\.?\s/i, 'Doctor ')
  }

  return mentorName
}
